import {
  APP_REFERER,
  AppErrorResponse,
  useGlobalAuth,
} from '@jaam/web-core';

interface UseAuthParams {
  onSuccess?: (data: any) => void;
  onError?: (error: AppErrorResponse) => void;
}

export const useAuth = ({ onSuccess, onError }: UseAuthParams = {}) => {
  return useGlobalAuth({
    onSuccess,
    onError,
    appReferrer: APP_REFERER.PAYROLLR,
  });
};
